// crisisDetect.js — deterministic, on-device check for crisis language in
// free text (check-in notes, journal entries). Runs for EVERY user: no AI
// call, no consent gate, no network, nothing stored or sent anywhere. The
// only effect of a match is a calm resource card with 988 and the Crisis
// Text Line. This is the fallback the AI paths cannot provide: the model's
// distress override (api/coach.js) only exists for users with AI consent,
// and PHQ-2 contains no self-harm item, so without this a direct disclosure
// in free text could pass with no resource shown.
//
// The list errs toward matching: the cost of a false positive is one
// dismissible card offering help. It is NOT a severity classifier and must
// never be used to label, score, or message anything beyond showing the
// card.

const CRISIS_PATTERNS = [
  /suicid/i,                                   // suicide, suicidal
  /kill(?:ing)?\s+myself/i,
  /end(?:ing)?\s+my\s+life/i,
  /end\s+it\s+all/i,
  /take\s+my\s+(?:own\s+)?life/i,
  /want(?:ed)?\s+to\s+die/i,
  /wanna\s+die/i,
  /wish\s+i\s+(?:was|were)\s+dead/i,
  /better\s+off\s+dead/i,
  /better\s+off\s+without\s+me/i,
  /no\s+reason\s+to\s+live/i,
  /not\s+worth\s+living/i,
  /life\s+is(?:n'?t| not)\s+worth/i,
  /can'?t\s+go\s+on/i,
  /can\s+not\s+go\s+on/i,
  /don'?t\s+want\s+to\s+be\s+here/i,
  /don'?t\s+want\s+to\s+exist/i,
  /no\s+point\s+(?:in\s+)?(?:living|going\s+on)/i,
  /hurt(?:ing)?\s+myself/i,
  /harm(?:ing)?\s+myself/i,
  /self[\s-]?harm/i,
  /cut(?:ting)?\s+myself/i,
  /no\s+way\s+out/i,
];

export function containsCrisisLanguage(text) {
  if (typeof text !== "string" || !text.trim()) return false;
  return CRISIS_PATTERNS.some((re) => re.test(text));
}
